import { render, staticRenderFns } from "./MoveContract.vue?vue&type=template&id=35e02f30&scoped=true&"
import script from "./MoveContract.vue?vue&type=script&lang=js&"
export * from "./MoveContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e02f30",
  null
  
)

export default component.exports